import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSubscriptionStatus } from '../hooks/useSubscriptionStatus';

const SubscriptionGuard = ({ children }) => {
  const { isSubscribed, isLoading, error, trialExpired } = useSubscriptionStatus();
  const location = useLocation();
  const navigate = useNavigate();

  const allowedPaths = [
    '/app/subscribe',
    '/app/onboarding',
    '/app/profile',
    '/app/profile/edit',
    '/app/profile/welcome'
  ];

  const isAllowedPath = allowedPaths.some(path => location.pathname.startsWith(path));

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#faf9f7] dark:bg-[#0a0a0a]">
        <div className="w-5 h-5 border-2 border-gray-300 dark:border-gray-700 border-t-[#f97316] rounded-full animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#faf9f7] dark:bg-[#0a0a0a] px-6">
        <div className="w-full max-w-[400px] text-center">
          <div className="p-3.5 bg-red-50 dark:bg-red-950/30 border border-red-100 dark:border-red-900/40 rounded-xl mb-6">
            <p className="text-[13px] text-red-600 dark:text-red-400">{error}</p>
          </div>
          <button
            onClick={() => window.location.reload()}
            className="px-6 py-3 bg-[#f97316] hover:bg-[#ea580c] text-white text-[14px] font-medium rounded-xl transition-colors"
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  if (isAllowedPath) {
    return children;
  }

  if (!isSubscribed) {
    return (
      <div className="fixed inset-0 z-[9999] bg-[#faf9f7] dark:bg-[#0a0a0a]">
        <div className="flex items-center justify-center min-h-screen px-6">
          <div className="w-full max-w-[400px] text-center">
            <span className="text-[11px] tracking-[0.3em] text-gray-400 dark:text-gray-600 font-light uppercase block mb-10">
              K L O R A H
            </span>

            <h2 className="text-[1.75rem] font-light tracking-tight text-gray-900 dark:text-white mb-3">
              Subscription required
            </h2>

            <p className="text-[15px] text-gray-400 dark:text-gray-500 mb-10 max-w-xs mx-auto">
              {trialExpired
                ? 'Subscribe to continue using Klorah. All your data is safe.'
                : 'Subscribe to Klorah to access all features.'}
            </p>

            <div className="space-y-3">
              <button
                onClick={() => navigate('/app/subscribe' + (trialExpired ? '?reason=subscription_required' : ''))}
                className="w-full py-4 bg-[#f97316] hover:bg-[#ea580c] text-white text-[15px] font-medium rounded-xl transition-colors"
              >
                Subscribe
              </button>

              <button
                onClick={() => navigate(-1)}
                className="w-full py-3 text-[14px] text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
              >
                Go back
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default SubscriptionGuard;
